import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { filterCommonAttributes } from '../ai-answer-dialog/analytics-helpers';
import type { commonAttributesType } from '../ai-answer-dialog/types';

import type { KnowledgeCardsIntentType } from './types';

export const onKnowledgeCardShown = (
	props: commonAttributesType & { cardType: KnowledgeCardsIntentType },
): AnalyticsEventPayload => {
	const { source, cardType } = props;
	return {
		action: 'shown',
		actionSubject: 'aiAnswerDialog',
		actionSubjectId: 'knowledgeCard',
		source: source,
		eventType: 'track',
		attributes: {
			...filterCommonAttributes(props),
			cardType,
		},
	};
};
